function initBrowser() {
  const u = navigator.userAgent;
  const {
    width,
    height,
  } = window.screen;

  const browser = {
    safari: u.indexOf('Safari') > -1,
    trident: u.indexOf('Trident') > -1, // IE内核
    presto: u.indexOf('Presto') > -1, // opera内核
    webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
    gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
    ios: !!(u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || u.indexOf('Mac OS X') > -1), // ios终端
    android: u.indexOf('Android') > -1, // android终端
    iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone
    iPad: u.indexOf('iPad') > -1, // 是否iPad
    isPlus: u.indexOf('iPhone') > -1 && ((width === 414 && height === 736) || (width === 736 && height === 414)),
    isIphoneX: u.indexOf('iPhone') > -1 && (
      (height === 812 && width === 375) || (height === 375 && width === 812)
      || (height === 896 && width === 414) || (height === 414 && width === 896)
    ),
    isIphoneXMax: u.indexOf('iPhone') > -1 && (
      (height === 896 && width === 414) || (height === 414 && width === 896)
    ),
    isIphone5: u.indexOf('iPhone') > -1 && (height === 568 && width === 320),
    webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
    language: (navigator.browserLanguage || navigator.language).toLowerCase(),
    lanxin: u.indexOf('es360messenger') > -1,
    gwssi: u.indexOf('GwssiG') > -1,
    GwssiG: u.indexOf('GwssiG') > 0, // 是否自己的中台
    weChat: u.toLowerCase().indexOf('micromessenger') > -1, // 是否在微信浏览器
  };
  window.browser = {
    ...browser,
    inNative: browser.toutiao || browser.super,
    getSystem: browser.ios ? 'ios' : 'android',
  };
}
initBrowser();
